module.exports = __webpack_public_path__ + "static/img/store_banner.cdb7e1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/store_banner.jpg
// module id = 49
// module chunks = 1